import { Component } from 'react';

import './Leaflet.scss';

class LeafletProvider extends Component {
  state = {
    leaflet: undefined,
  };

  componentDidMount() {
    // Leaflet does not load correctly on the server, cDM is only called
    // client-side, allowing children of this provider to render maps
    // conditionally based on whether leaflet does or doesn't exist
    this.loadLeaflet();
  }

  loadLeaflet = async () => {
    let libraries = [
      import(/* webpackChunkName: "leaflet" */ 'react-leaflet'),
      import(/* webpackChunkName: "leaflet" */ 'react-leaflet-div-icon'),
    ];

    libraries = await Promise.all(libraries);

    let leaflet = {
      Map: undefined,
      TileLayer: undefined,
      ZoomControl: undefined,
      DivIcon: undefined,
    };
    if (libraries[0]) leaflet = { ...leaflet, ...libraries[0] };
    if (libraries[1]) leaflet = { ...leaflet, DivIcon: libraries[1].default };

    this.setState({ leaflet });
  };

  render() {
    return this.props.render({ leaflet: this.state.leaflet });
  }
}

export default LeafletProvider;
